import axios from "axios";
import "bootstrap-css-only/css/bootstrap.min.css";
import "core-js";
import "moment/locale/vi";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Route, Router, Switch } from "react-router-dom";
import "~/api/axios.config";
import "~/assets/scss/mdb.scss";
import ScrollToTop from "~/components/common/atoms/ScrollToTop";
import { ToastNotification } from "~/components/common/molecules/ToastNotification";
import styles from "~/components/desktop/templates/AuthTemplate/style.module.scss";
import history from "~/history";
import listRouters from "~/utils/listRouter";
import { client } from "~/utils/medproSDK";
import AppId from "~/utils/partner";
import {
  getExtraConfig,
  requestHospitalInfo,
  requestHospitalDescription
} from "./store/totalData/actions";
import * as hand from "./utils/handerRoot";
import Helmet from "react-helmet";
import cx from "classnames";
import { Page404 } from "~/components/common/molecules/Page404";

class Root extends React.Component {
  constructor(props) {
    super(props);
    axios.defaults.headers.appid = AppId;
    axios.defaults.headers.partnerid = AppId;
    this.state = {
      lastScrollY: 0,
      scrollingDown: false
    };
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const currentScrollY = window.scrollY;
    const scrollingDown = currentScrollY > this.state.lastScrollY;

    this.setState({
      lastScrollY: currentScrollY,
      scrollingDown
    });
    console.log("scrollingDown", scrollingDown);
  };

  componentDidMount() {
    const { global, user, getExtraConfig } = this.props;

    window.addEventListener("scroll", this.handleScroll);

    getExtraConfig();

    this.props.requestHospitalInfo({ partnerId: AppId });
    this.props.requestHospitalDescription({ slug: AppId });

    // platform
    const typeDv = global.device.type;
    client.setPlatform(typeDv === "desktop" ? "pc" : "web");

    // token
    const jwt = window.localStorage.getItem("jwt");
    const token = user?.info?.token || jwt;
    client.setToken(token);
    const { type, TYPE_RELOAD } = performance.navigation;

    if (window.performance) {
      console.info("window.performance works fine on this browser");
      client.setToken(token || jwt);

      if (type === TYPE_RELOAD) {
        console.info("This page is reloaded");
        client.setToken(jwt);
      } else {
        console.info("This page is not reloaded");
        client.setToken(token);
      }
    }
  }

  handleCanonical = () => {
    const urlPage = window.location.href;
    const clearParamse = urlPage.split("?")[0];
    const clearSlash = clearParamse.replace(/\/$/, "");
    console.log("clearSlash", clearSlash);
    return clearSlash;
  };

  handleMeta = () => {
    const { selectedHospital } = this.props;
    return [
      {
        property: `og:image`,
        content: selectedHospital?.circleLogo || selectedHospital?.image
      },
      {
        property: `og:url`,
        content: this.handleCanonical()
      },
      {
        property: `zalo:og:image`,
        content: selectedHospital?.circleLogo || selectedHospital?.image
      }
    ];
  };

  render() {
    const { scrollingDown } = this.state;
    return (
      <>
        <Router history={history}>
          <Route
            render={({ location }) => {
              const pathname = location.pathname;
              return (
                <Fragment>
                  <Helmet>
                    {this.handleMeta()?.map((item, index) => (
                      <meta
                        property={item?.property}
                        content={item?.content}
                        key={index}
                      />
                    ))}
                    <link rel="canonical" href={this.handleCanonical()} />
                  </Helmet>
                  <div className={styles.wrapper_template}>
                    {/* -------------- phần header --------------  */}
                    {hand.handlerHeader(pathname)}
                    {/* -------------- phần main content --------------  */}
                    <div
                      className={cx(
                        styles.wrapper_content,
                        !scrollingDown &&
                          history?.location?.pathname !== "/" &&
                          styles.scrollingDown
                      )}
                    >
                      <Switch location={location}>
                        {listRouters.map(item => {
                          // trường hợp page có childDynamic; vi dụ dalieuhcm/đặt lịch khám
                          if (item.childDynamic) {
                            return item.childDynamic.map(itemChild => {
                              return hand.handerContent(
                                itemChild,
                                true,
                                item.path
                              );
                            });
                          }
                          // trường hợp page bình thuòng
                          else {
                            return hand.handerContent(item);
                          }
                        })}
                        {/* Các trường hợp khác chạy về home */}

                        <Route path="*" render={() => <hand.NoMatch />} />
                      </Switch>
                      <ScrollToTop />
                    </div>
                    {/* -------------- phần footer --------------------- */}
                    {hand.handlerFooter(pathname)}{" "}
                  </div>
                </Fragment>
              );
            }}
          />
        </Router>
        <ToastNotification />
      </>
    );
  }
}

const mapStateToProps = state => {
  const {
    totalData,
    global,
    user,
    hospital: { selectedHospital }
  } = state;
  return {
    totalData,
    user,
    global,
    selectedHospital
  };
};

const mapDispatchToProps = {
  getExtraConfig: getExtraConfig,
  requestHospitalInfo: requestHospitalInfo,
  requestHospitalDescription: requestHospitalDescription
};

export default connect(mapStateToProps, mapDispatchToProps)(Root);
// export default Root;
